import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/staking.svg'
import _imports_1 from '@/assets/images/epoch.svg'
import _imports_2 from '@/assets/images/slot.svg'
import _imports_3 from '@/assets/images/calendar.svg'
import _imports_4 from '@/assets/images/clock.svg'


const _withScopeId = n => (_pushScopeId("data-v-90a3b6d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-4"
}, null, -1))
const _hoisted_2 = { class: "mr-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-4"
}, null, -1))
const _hoisted_4 = { class: "mr-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-4"
}, null, -1))
const _hoisted_6 = { class: "mr-4" }
const _hoisted_7 = { class: "text-cut" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mr-4"
}, null, -1))
const _hoisted_9 = { class: "mr-4" }
const _hoisted_10 = { class: "text-cut" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "mr-4"
}, null, -1))
const _hoisted_12 = { class: "text-cut" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "transaction-details__copy-icon bg-primary mr-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mt-4",
    src: _imports_4
  })
], -1))
const _hoisted_14 = { class: "text-cut" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-4"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "transaction-details__arrow-right bg-light" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullWrapContainer = _resolveComponent("FullWrapContainer")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_BlockCardLayoutBoxedItem = _resolveComponent("BlockCardLayoutBoxedItem")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_BlockCardLayout = _resolveComponent("BlockCardLayout")!

  return (_openBlock(), _createBlock(_component_BlockCardLayout, {
    class: "transaction-details-outline",
    hoverable: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        active: "",
        paragraph: { rows: 1 },
        loading: _ctx.loading || _ctx.transactionDetails == undefined
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BlockCardLayoutBoxedItem, { class: "mb-10 transaction-details__content-details" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { align: "middle" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t("hash")), 1),
                  _createVNode(_component_FullWrapContainer, {
                    title: _ctx.t('hash'),
                    content: _ctx.transactionDetails?.hash
                  }, null, 8, ["title", "content"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_BlockCardLayoutBoxedItem, { class: "mb-10 transaction-details__content-details" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { align: "middle" }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t("block")), 1),
                  _createVNode(_component_FullWrapContainer, {
                    title: _ctx.t('block'),
                    content: _ctx.transactionDetails?.block
                  }, null, 8, ["title", "content"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_BlockCardLayoutBoxedItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 10,
                    xs: 24,
                    sm: 10
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, {
                        wrap: false,
                        align: "middle"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5,
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t("Epoch")), 1),
                          _createElementVNode("span", _hoisted_7, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.transactionDetails?.epoch), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, {
                        wrap: false,
                        align: "middle"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t("Slot")), 1),
                          _createElementVNode("span", _hoisted_10, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.transactionDetails?.slot), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 7,
                    xs: 24,
                    sm: 7
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, {
                        wrap: false,
                        align: "middle"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.transactionDetails?.date), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 7,
                    xs: 24,
                    sm: 7
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, {
                        wrap: false,
                        align: "middle"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13,
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.transactionDetails?.time), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.transactionDetails.message)
            ? (_openBlock(), _createBlock(_component_BlockCardLayoutBoxedItem, {
                key: 0,
                class: "mb-10 transaction-details__content-details"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    wrap: false,
                    align: "middle"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("Message")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createElementVNode("b", null, _toDisplayString(_ctx.transactionDetails.message), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _hoisted_16
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}